// Ported from DibApp2020/ClientApp/src/components/utilities/getContentDispFileName.ts.
// Inspiration from https://github.dev/jshttp/content-disposition if more checks are needed.

const ENCODED_FILENAME_REGEX =
    /(?:.*filename\*|filename)=(?:([^'"]*)''([^;\s]*)|"([^"]*)")/;
const FILENAME_REGEX = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

export const getContentDispFilename = (
    contentDisposition?: string | null,
): string | undefined => {
    if (!contentDisposition) return undefined;

    if (contentDisposition.indexOf(`filename*=UTF-8''`) > -1) {
        const starMatches = ENCODED_FILENAME_REGEX.exec(contentDisposition);
        if (starMatches !== null && starMatches[2]) {
            return decodeURIComponent(starMatches[2]).replace(/['"]/g, "");
        }
    } else {
        const filenameMatches = FILENAME_REGEX.exec(contentDisposition);
        if (filenameMatches !== null && filenameMatches[1]) {
            return filenameMatches[1].replace(/['"]/g, "");
        }
    }

    return undefined;
};
